import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { cleanError } from "../Steps/Phone/slice";
import { validateInputByPassportType } from "../Steps/RegisterForm/functions/inputValidation";
import { useTranslation } from "react-i18next";

interface UseNameInputProps {
  citizenshipId: number | null;
  fieldName: string;
  currentValue: string;
  onUpdate: (value: string) => void;
}

export const useNameInput = ({
  citizenshipId,
  fieldName,
  onUpdate,
}: UseNameInputProps) => {
  const { error } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  const [validationError, setValidationError] = useState<string>("");
  const { t } = useTranslation();

  // Очищаем ошибку валидации при смене типа паспорта
  useEffect(() => {
    setValidationError("");
  }, [citizenshipId]);

  const handleChange = (currentValue: string) => {
    // Сохраняем введенное значение как есть
    onUpdate(currentValue);

    // Проверяем валидность
    if (citizenshipId === null) {
      setValidationError("");
    } else {
      const validation = validateInputByPassportType(
        currentValue,
        citizenshipId
      );
      if (!validation.isValid) {
        const errorMessage = validation.errorMessageKey ? t(validation.errorMessageKey) : '';
        setValidationError(errorMessage);
      } else {
        setValidationError("");
      }
    }

    // Очищаем серверную ошибку
    if (error[fieldName]) {
      dispatch(cleanError(fieldName));
    }
  };

  const displayError = validationError || error[fieldName];

  return {
    handleChange,
    displayError,
  };
};
